export enum OrderSubState {
  OrderCreated = 'orderCreated',
  LabProcess = 'labProcess',
  Report = 'report',
  FollowUpTasks = 'followUpTasks',
  Completed = 'completed',
}

export type DiagnosticReportReviewAction =
  | 'approved'
  | 'changes-requested'
  | 'comment';

export type DiagnosticReportReviewStatus =
  | 'approved'
  | 'changes-requested'
  | 'pending';

export enum PaymentSource {
  ELKE = 'ELKE',
  EPI = 'EPI',
  HOSPITAL = 'CLOSED_HOSPITALIZATION',
  PRESCRIPTION = 'PRESCRIPTION',
  OTHER = 'OTHER',
}

export type PaymentStatus = 'draft' | 'issued' | 'balanced' | 'cancelled';
